import { Input, Component, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AbstractValueAccessor, MakeProvider } from './abstract-value-accessor';
import { FormField } from '../models/form-field';
import { Util } from '../utils/utils.module';

@Component({
  selector: 'edx-read-only-text-field',
  providers: [MakeProvider(ReadOnlyTextFieldComponent)],
  styleUrls: ['dynamic-form-field.component.scss'],
  template: `
  <div [formGroup]="form" class="textfield" [tabindex]="(field.name==='save_search_as' || field.name==='update_saved_search')?33:-1" [attr.role]="field.name==='save_search_as'?'note':null" [ngClass]="{indialog:inDialog, columnview:columnView, fullwidth:fullWidth, hasextension:hasExtension, oai:officeAddin}" [title]="toolTip">
    <ng-template  ngFor let-line [ngForOf]="lines" let-i="index">
      <br *ngIf="i>0 && formKind != 'shortcuts'">
      <span [ngClass]="{key: (i%2 === 0) && formKind == 'shortcuts', errorkey: formKind === 'shortcuts' && !!field.errormessage}">{{line}}</span>
    </ng-template>
  </div>
`
})
export class ReadOnlyTextFieldComponent extends AbstractValueAccessor implements OnChanges {
  @Input() field: FormField;
  @Input() form: FormGroup;
  @Input() inDialog?: boolean = false;
  @Input() columnView?: boolean = false;
  @Input() toolTip?: string = '';
  @Input() fullWidth?: boolean = false;
  @Input() hasExtension?: boolean = false;
  @Input() rerender = 0;
  @Input() formKind?: string='';
  public lines: string [];
  public officeAddin = Util.Device.bIsOfficeAddin;

  ngOnChanges() {
    this.value = this.form.controls[this.field.name].value;
    if (this.field.controltype === 'textarea' || this.formKind === 'shortcuts') {
      this.lines = this.value.split('\n');
    } else if (this.field.controltype === 'radiogroup') {
      const button = this.field.buttonMap.find(b => b.value === this.value);
      this.lines = !!button ? [button.display] : [this.value];
    } else if (this.field.name === 'DOCNUM' && isNaN(+this.value)) {
      this.lines = [];
    } else {
      this.lines = [this.value];
    }
  }
}
